var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDevicesIconDark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 21,
  viewBox: "0 0 24 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13_568)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.5737 0.599976H2.42645C1.46511 0.599976 0.685791 1.33871 0.685791 2.24998V8.84997C0.685791 9.76123 1.46511 10.5 2.42645 10.5H21.5737C22.5351 10.5 23.3144 9.76123 23.3144 8.84997V2.24998C23.3144 1.33871 22.5351 0.599976 21.5737 0.599976Z",
  stroke: "#EEEEEE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.90768 6.37498C6.38835 6.37498 6.77801 6.00561 6.77801 5.54998C6.77801 5.09434 6.38835 4.72498 5.90768 4.72498C5.42702 4.72498 5.03735 5.09434 5.03735 5.54998C5.03735 6.00561 5.42702 6.37498 5.90768 6.37498Z",
  stroke: "#EEEEEE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8704 5.54993H18.9627",
  stroke: "#EEEEEE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.42645 10.5C1.96479 10.5 1.52206 10.6738 1.19562 10.9833C0.869182 11.2927 0.685791 11.7124 0.685791 12.15V18.75C0.685791 19.1876 0.869182 19.6073 1.19562 19.9167C1.52206 20.2261 1.96479 20.4 2.42645 20.4H21.5737C22.0353 20.4 22.4781 20.2261 22.8045 19.9167C23.1309 19.6073 23.3144 19.1876 23.3144 18.75V12.15C23.3144 11.7124 23.1309 11.2927 22.8045 10.9833C22.4781 10.6738 22.0353 10.5 21.5737 10.5",
  stroke: "#EEEEEE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.90768 16.275C6.38835 16.275 6.77801 15.9056 6.77801 15.45C6.77801 14.9944 6.38835 14.625 5.90768 14.625C5.42702 14.625 5.03735 14.9944 5.03735 15.45C5.03735 15.9056 5.42702 16.275 5.90768 16.275Z",
  stroke: "#EEEEEE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8704 15.45H18.9627",
  stroke: "#EEEEEE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13_568"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 21,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDevicesIconDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/devicesIcon_dark.08bbfcf6c4b39b3260c9260b16dba1aa.svg";